<div class="modal-container">
  <div class="modal-top">
    <h1 mat-dialog-title>{{ customerFeature.label }}</h1>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <div [innerHTML]="customerFeature.bookingModalContent"></div>
  </div>

  <div class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'block'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>
</div>
